<template>
    <div>
        <loader :loader="isLoading" v-if="isLoading" />
        <b-col v-else class="p-0">
            <div class="d-inline-flex flex-wrap flex-column w-100 pendencies-gap">
                <humor v-if="humorPendencies.length" :questions="humorPendencies" :update="getPendencies" />
                <enps :userId="user.id" :questions="enpsPendencies" :update="getPendencies" />
                <values-pendencies :pending-evaluations="pendingEvaluations" />
            </div>
        </b-col>
    </div>
</template>

<script>
import { geteNPSPendencies, getHumorPendencies, getPendingEvaluations } from './api'
import Loader from '@/views/components/loader'
import { Enps, Humor, ValuesPendencies } from './children'

export default {
    name: 'Pendencies',
    components: {
        Loader,
        Enps,
        Humor,
        ValuesPendencies,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        haseNPSModule: {
            type: Boolean,
            required: true,
        },
        hasMoodPulseModule: {
            type: Boolean,
            required: true,
        },
        hasValuesModule: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            enpsPendencies: [],
            humorPendencies: [],
            pendingEvaluations: [],
            isLoading: true,
        }
    },
    mounted() {
        this.getPendencies()
    },
    methods: {
        async getPendencies() {
            this.isLoading = true
            if (this.haseNPSModule) {
                await geteNPSPendencies(this.user.id).then((data) => (this.enpsPendencies = data))
            }

            if (this.hasMoodPulseModule) {
                await getHumorPendencies().then((data) => (this.humorPendencies = data))
            }

            await getPendingEvaluations(this.user.id).then((data) => (this.pendingEvaluations = data))

            this.$emit(
                'hasPendency',
                !!this.enpsPendencies.length || !!this.humorPendencies.length || !!this.pendingEvaluations.length
            )

            this.isLoading = false
        },
    },
}
</script>
<style lang="scss" scoped>
.title {
    color: #6e6e6e;
}
.pendencies-gap {
    gap: 0.5rem;
}
</style>
